import env from '@constants/env'
import moment from 'moment'

const dateFormat = 'Do MMM, YYYY'
const date = d => moment(d).format(dateFormat)

// export const getBusinessDetails = record => {}

export const getCertMap = (type, f) => {
  switch (type) {
    case 'PlantsImportLicense':
    case 'PoultryImportLicense':
    case 'DairyImportLicense':
    case 'MeatImportLicense':
    case 'BananaImport':
    case 'FruitAndVeggie':
    case 'EggsImport':
    case 'OrchidImportLicense':
      return [
        ['Permit Details'],
        ['Issue Date', date(f.license_approval_date)],
        ['Exp. Date', date(f.license_expiry_date)],
        ['Port of Entry', f.entry_port],
        ['Country of Origin', f.country_origin],
      ]
    case 'PoliceCertificate':
      return [
        f.license_numb ? ['Licence Number', f.license_numb] : ['BLANK'],
        ['SPACE'],
        ['Applicant Details', 'HEADER'],
        ['Date Of Birth', date(f.user.date_of_birth)],
        [
          'Place Of Birth',
          f.birth_place == 'Bahamas'
            ? `${f.birth_island}, Bahamas`
            : f.birth_place,
        ],
        ['SPACE'],
        ['Passport Details', 'HEADER'],
        f.passport_number ? ['Passport Number', f.passport_number] : ['SPACE'],
        ['Issuing Country', f.passport_issue_country || 'The, Bahamas'],
        ['SPACE'],
        ['TABLE',
          (
            <div>
              <img src={`${env.WEB_SERVICE_URL}/${f.image[2]}`} style={{maxWidth: '200px', height: 'auto'}} alt='Profile'></img>
            </div>
          ) || 'No Image'],
        ['Criminal History', 'HEADER'],
        ['TABLE',
          (
            <div>
              <table className="table-auto" style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th className="px-4 py-2 text-left">Date</th>
                    <th className="px-4 py-2 text-right">Offence/s</th>
                    {/* <th className="px-4 py-2">Sentence</th> */}
                  </tr>
                </thead>
                <tbody>
                  {f?.criminal_history_list?.map((x, index) => (
                    <tr key={index} className={index % 2 == 0 ? '' : 'bg-gray-300'}>
                      <td className='uppercase py-2'>{x.date?.split('T')[0]}</td>
                      <td className='uppercase px-3 py-2 text-right'>{x.conviction}</td>
                      {/* <td className='uppercase px-2 py-2 text-right'>{x.sentence}</td> */}
                    </tr>
                  ))}
                  {f.criminal_history_list?.length == 0 && (
                    <tr>
                      <td className='fw-bold uppercase py-2' colSpan={2}>No Criminal History</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            ) || 'No Criminal History'],
        // ['National Insurance Number', f.user.NIB],
        // [`Driver's Licence Number`, f.user.drivers_license_number],
      ]
    case 'GreenChoiceExemption':
      return [
        f.license_numb ? ['Licence Number', f.license_numb] : ['BLANK'],
        f.license_numb ? ['Issue Date', f.license_approval_date] : ['BLANK'],
        f.license_numb ? ['Expiry Date', f.license_expiry_date] : ['BLANK'],
        ['SPACE'],
        ['Eligible Appliances', 'HEADER'],
        ['TABLE',
          (
            <div>
              <table className="table-auto" style={{width: '100%', maxWidth: '400px', margin: '0 auto'}}>
                <thead>
                  <tr>
                    <th className="px-3 py-2 text-left">Appliance Type</th>
                    <th className="px-3 py-2 text-right">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='uppercase px-3 py-2 text-left'>Refrigerator</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.fridge_quantity || 0}</td>
                  </tr>
                  <tr className='bg-gray-300'>
                    <td className='uppercase px-3 py-2 text-left'>Freezer</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.freezer_quantity || 0}</td>
                  </tr>
                  <tr>
                    <td className='uppercase px-3 py-2 text-left'>Air conditioner</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.air_conditioner_quantity || 0}</td>
                  </tr>
                  <tr className='bg-gray-300'>
                    <td className='uppercase px-3 py-2 text-left'>Water heater</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.water_heater_quantity || 0}</td>
                  </tr>
                  <tr>
                    <td className='uppercase px-3 py-2 text-left'>Walk-in freezer</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.walk_in_freezer_quantity || 0}</td>
                  </tr>
                  <tr className='bg-gray-300'>
                    <td className='uppercase px-3 py-2 text-left'>Walk-in Refrigerator</td>
                    <td className='uppercase px-3 py-2 text-right'>{f.walk_in_fridge_quantity || 0}</td>
                  </tr>                                                                                          
                </tbody>
              </table>
            </div>
            ) || 'Not Eligible'],
        // ['National Insurance Number', f.user.NIB],
        // [`Driver's Licence Number`, f.user.drivers_license_number],
      ]
    case 'Moen::Depp::EnvClearanceSuppForm':
      return [
        ['SPACE'],
        ['Permit Details', 'HEADER'],
        ['Issue Date', date(f.license_approval_date)],
        f.license_expiry_date ? ['Exp. Date', date(f.license_expiry_date)] : ['Exp. Date','N/A'],
        ['SPACE'],
        ['Project Description', 'HEADER'],
        ['Project Island', f.project_island],
        ['Activities', f.all_activities_list?.join(', ')],
        ['TABLE',
          (
            <div>
              <table className="table-auto" style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th className="py-2 text-left">Purpose</th>
                    {/* <th className="px-4 py-2">Sentence</th> */}
                  </tr>
                </thead>
                <tbody>
                  {f?.purpose_list?.map((x, index) => (
                    <tr key={index} className={index % 2 == 0 ? '' : 'bg-gray-300'}>
                      <td className='uppercase px-3 py-2 text-right'>{x}</td>
                      {/* <td className='uppercase px-2 py-2 text-right'>{x.sentence}</td> */}
                    </tr>
                  ))}
                  {f.purpose_list?.length == 0 && (
                    <tr>
                      <td className='fw-bold uppercase py-2' colSpan={2}>No Purpose</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            ) || 'No Purpose'],
      ]
    case 'Moen::Depp::EnvClearancePartB':
      return [
        ['SPACE'],
        ['Permit Details'],
        ['Issue Date', date(f.license_approval_date)],
        f.license_expiry_date ? ['Exp. Date', date(f.license_expiry_date)] : ['Exp. Date', 'N/A'],
        ['SPACE'],
        ['Project Description'],
        ['Project Island', f.form_part_a?.project_island],
        ['Activities', f.form_part_a?.all_activities_list?.join(', ')],
        ['TABLE',
          (
            <div>
              <table className="table-auto" style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th className="py-2 text-left">Purpose</th>
                    {/* <th className="px-4 py-2">Sentence</th> */}
                  </tr>
                </thead>
                <tbody>
                  {f?.form_part_a?.purpose_list?.map((x, index) => (
                    <tr key={index} className={index % 2 == 0 ? '' : 'bg-gray-300'}>
                      <td className='uppercase px-3 py-2 text-right'>{x}</td>
                      {/* <td className='uppercase px-2 py-2 text-right'>{x.sentence}</td> */}
                    </tr>
                  ))}
                  {f.form_part_a?.purpose_list?.length == 0 && (
                    <tr>
                      <td className='fw-bold uppercase py-2' colSpan={2}>No Purpose</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            ) || 'No Purpose'],
      ]
    default:
      return [['SPACE']]
  }
}
